module.exports = __webpack_public_path__ + "img/devon-logo.5d440f42.png";